'use strict';

var _Minima = require('../Minima');

var _Minima2 = _interopRequireDefault(_Minima);

var _Framework = require('../core/Framework');

var _Framework2 = _interopRequireDefault(_Framework);

var _PluginInstaller = require('../core/PluginInstaller');

var _PluginInstaller2 = _interopRequireDefault(_PluginInstaller);

var _EventManager = require('../core/EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _unit = require('unit.js');

var _unit2 = _interopRequireDefault(_unit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// test suite
describe('PluginInstaller', function () {
        // test case
        it('should be loaded correctly', function () {
                var minima = new _Minima2.default(_path2.default.join(__dirname, 'plugins'));
                minima.start();

                var demoPlugin2 = minima.getPlugin('demoPlugin2');
                demoPlugin2.stop();
                demoPlugin2.start();

                _unit2.default.number(minima.framework.pluginInstaller.plugins.size).is(2);

                minima.stop();
        });
});
//# sourceMappingURL=testPluginInstaller.js.map